import axios from 'axios'
import firebaseConfig from 'configs/FirebaseConfig'
const instanceZS = axios.create({
  baseURL: `https://${process.env.REACT_APP_REGION}-${firebaseConfig.projectId}.cloudfunctions.net/`,
})
export default instanceZS
